import { useTheHeaderProps } from "./fetch";
import { TheHeader as Component } from "./ui/TheHeader";

type Props = {
  onMobileSidebarOpen: () => void;
};

export const TheHeader = ({ onMobileSidebarOpen }: Props) => {
  const props = useTheHeaderProps();
  return <Component {...props} onMobileSidebarOpen={onMobileSidebarOpen} />;
};
